"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaqueBleedingIndexExam_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var Patient_1 = require("./Patient");
var PlaqueBleedingIndexTeeth_1 = require("./PlaqueBleedingIndexTeeth");
var PlaqueBleedingIndexExam_Factory = /** @class */ (function () {
    function PlaqueBleedingIndexExam_Factory() {
    }
    PlaqueBleedingIndexExam_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Patient: Patient_1.Patient_Factory.CreateIncoming(model.Patient),
            PatientId: model.PatientId,
            PlaqueBleedingIndexTeethSet: model.PlaqueBleedingIndexTeethSet && model.PlaqueBleedingIndexTeethSet.map(function (i) { return PlaqueBleedingIndexTeeth_1.PlaqueBleedingIndexTeeth_Factory.CreateIncoming(i); }),
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordedBy: model.RecordedBy,
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    PlaqueBleedingIndexExam_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Patient: Patient_1.Patient_Factory.CreateOutgoing(model.Patient),
            PatientId: model.PatientId,
            PlaqueBleedingIndexTeethSet: model.PlaqueBleedingIndexTeethSet && model.PlaqueBleedingIndexTeethSet.map(function (i) { return PlaqueBleedingIndexTeeth_1.PlaqueBleedingIndexTeeth_Factory.CreateOutgoing(i); }),
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordedBy: model.RecordedBy,
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return PlaqueBleedingIndexExam_Factory;
}());
exports.PlaqueBleedingIndexExam_Factory = PlaqueBleedingIndexExam_Factory;
